import {Component, Vue} from 'vue-property-decorator';
import {ensureChatwootUserIdentified, isChatwootUserSynchronized} from '@/services/utils/chatwoot';

@Component
export default class IntercomMixin extends Vue {
  get isIntercomOpen(): boolean {
    return this.$store.state.tabChatVis
  }

  openLiveSupport() {
    if(this.$FF.chatwoot?.enabled){
      const {user} = this.$store.state;
      const openWidget = () => (window as any).$chatwoot.toggle('open');

      if (!user?.id) {
        return;
      }

      if ((window as any).$chatwoot?.toggle && isChatwootUserSynchronized(user)) {
        console.info('[chatwoot-sync] open-widget-fast-path', {userId: user.id});
        openWidget();
        return;
      }

      console.info('[chatwoot-sync] open-widget-after-sync', {userId: user.id});
      ensureChatwootUserIdentified(user)
        .then(openWidget)
        .catch((error) => {
          console.info('[chatwoot-sync] open-widget-sync-failed', {
            userId: user.id,
            message: error instanceof Error ? error.message : String(error),
          });

          if ((window as any).$chatwoot?.toggle) {
            openWidget();
          }
        });
    }else{
      this.$intercom?.show();
      this.$intercom?.boot({'hide_default_launcher': false});
      this.$store.commit('tabChatVis', true);
    }
  }

  closeLiveSupport() {
    if(this.$FF.chatwoot?.enabled){
      (window as any).$chatwoot.toggle('close');
    }else{
      this.$intercom?.hide();
      this.$intercom?.boot({'hide_default_launcher': true});
      this.$store.commit('tabChatVis', false)
    }
  }
}
